import { render, staticRenderFns } from "./TestReport.vue?vue&type=template&id=cc39f624&scoped=true"
import script from "./TestReport.vue?vue&type=script&lang=js"
export * from "./TestReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../wscpet/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc39f624",
  null
  
)

export default component.exports